const INITIAL_STATE = {
  type: '',
  counter: 0,
  mute: false,
};

export const SET_MUTE = 'SET_MUTE';
export const EMIT_SOUND = 'EMIT_SOUND';

export default function soundReducer(state = INITIAL_STATE, { type, name }) {
  switch (type) {
    case EMIT_SOUND:
      return {
        ...state,
        type: name,
        counter: state.counter + 1,
      };
    case SET_MUTE:
      return {
        ...state,
        mute: !state.mute,
      };
    default:
      return state;
  }
}
